import { eventLogger } from '../../eventLogger';
import type { LogAnalyticsEventParams } from './types';

export const logAnalyticsEvent = ({
  ably_only_log = {},
  name,
  channel = ['firebase', 'amplitude', 'ablylog', 'facebook'],
  ...restParams
}: LogAnalyticsEventParams) => {
  eventLogger.log({
    eventName: name,
    channel,
    ...restParams,
    ablyOnlyLog: ably_only_log,
  });
  return;
};
